export interface ExternalProvider {
  id: FirebaseAuthProviderId;      // firebase providerId e.g., 'google.com'
  name: string;    // Display name
  icon?: string;
}

export enum FirebaseAuthProviderId {
  GOOGLE= "google.com",
  FACEBOOK = "facebook.com",
  APPLE = "apple.com",
  PASSWORD = "password",
}

export const FIREBASE_AUTH_PROVIDERS: ExternalProvider[] = [
  {
    id: FirebaseAuthProviderId.GOOGLE,
    name: 'Google',
    icon: 'ic_social_google'
  },
  {
    id: FirebaseAuthProviderId.FACEBOOK,
    name: 'Facebook',
    icon: 'ic_social_facebook'
  },
  {
    id: FirebaseAuthProviderId.APPLE,
    name: 'Apple',
    icon: 'ic_social_apple'
  },
  {
    id: FirebaseAuthProviderId.PASSWORD,
    name: $localize `:@@common.emailAndPassword:Email & Password`
  },
];
